import { Collection } from 'modules/core/lib/mobx-rest'
import type { ModelAttributes } from 'modules/core/lib/mobx-rest'
import type { SetOptions } from 'modules/core/lib/mobx-rest/types'

import type { ICustomField } from 'modules/custom_resources/store/models/customFields/Field'
import CustomField from 'modules/custom_resources/store/models/customFields/Field'

export const FieldTypes = {
  text: 'text',
  date: 'date',
  longText: 'long_text',
  rating: 'rating',
  checkbox: 'checkbox',
  singleChoice: 'single_choice',
  multipleChoice: 'multiple_choice',
  cents: 'cents',
  money: 'money',
}

export const NumericFieldTypes = {
  rating: FieldTypes.rating,
  cents: FieldTypes.cents,
  money: FieldTypes.money,
}

export const RatingDefaultValues = {
  minValue: 0,
  maxValue: 10,
}

export const MaxOptionLabelLength = 255

const AutomationsUsageGroupSlugs = [
  'documents',
  'expenses',
  'employees-questions',
  'timetracking',
  'packages-employee-contract',
  'packages-office-info',
  'packages-legal-entity-info',
]
interface Config {
  model_ref: string
  instance_id: string | number
}

class CustomFields extends Collection<CustomField> {
  config: Config

  constructor(data: ModelAttributes<CustomField>[], config: Config) {
    super(data)
    this.set(data)
    this.config = config
  }

  get cacheKey(): string {
    return 'customFields'
  }

  private get dynamicPath() {
    const { instance_id, model_ref } = this.config
    let base_url = '/custom_fields'

    if (model_ref) base_url += `/${model_ref}/${instance_id}`

    return base_url
  }

  create(attributes: Partial<ICustomField>) {
    return super.create(attributes, { path: this.dynamicPath })
  }

  fetch(options: SetOptions = {}) {
    return super.fetch({ ...options, path: this.dynamicPath })
  }

  model() {
    return CustomField
  }

  byUsageGroup(groups: string[]): Promise<any> {
    return this.fetch({
      data: {
        usage_group_slug: groups,
      },
    })
  }

  byAutomationsUsageGroup(): Promise<any> {
    return this.byUsageGroup(AutomationsUsageGroupSlugs)
  }
}

export default CustomFields
